import React from "react";
import { Link } from "react-router";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { Application } from "@domain/application/application";
import { Person } from "@domain/user/user";
import { ApplicationStatus } from "@ui/components/application/applicationStatus";
import { Primary } from "@ui/components/containers/primary";
import { mobile } from "@ui/styles/utils";

interface ApplicationViewProps extends React.HTMLAttributes<HTMLDivElement> {
	application: Application;
}

export const ApplicationView: React.FC<ApplicationViewProps> = ({ application, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<Link to={Path.ApplicationSheet(application.person as Person)}>
				<StyledPrimary>{application.firstName.concat(" ", application.familyName)}</StyledPrimary>
			</Link>
			<StyledPrimary>{application.countryResidence}</StyledPrimary>
			<StyledPrimary>{application.level.name}</StyledPrimary>
			<StyledPrimary>{application.degree.name}</StyledPrimary>
			<ApplicationStatus isComplete={application.status === "PENDING_VALIDATION" ? true : false} />
		</Container>
	);
};

const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	grid-template-rows: auto;
	place-items: center;
	border-bottom: 1px solid rgba(114, 188, 243, 0.08);
	padding: 5px;
	text-align: center;
	height: 50px;
	transition: background-color 0.3s linear;
	:hover {
		background-color: rgba(114, 188, 243, 0.5);
		> :first-child :first-child {
			cursor: pointer;
			color: ${({ theme }) => theme.colors.secondary};
		}
	}

	@media ${mobile} {
		height: 75px;
		width: 100vw;
		overflow-x: scroll;
	}

	> :first-child :first-child {
		text-transform: capitalize;
		transition: color 0.3s linear;
	}
`;

const StyledPrimary = styled(Primary)`
	font-size: 0.875rem;
`;
